
import Vue from 'vue';

function parseMarkdownTable(text: string): { headers: string[]; rows: string[][] } {
  const lines = text.split('\n').map((l) => l.trim()).filter((l) => l.startsWith('|'));
  const isSeparator = (l: string) => /^\|[-| :]+\|$/.test(l);
  const parseRow = (l: string) => l.replace(/^\||\|$/g, '').split('|').map((c) => c.trim());
  const content = lines.filter((l) => !isSeparator(l));
  if (content.length === 0) return { headers: [], rows: [] };
  const [first, ...rest] = content;
  return { headers: parseRow(first), rows: rest.map(parseRow) };
}

export default Vue.extend({
  name: 'MarkdownTable',
  props: {
    text: { type: String, required: true },
  },
  computed: {
    headers(): string[] {
      return parseMarkdownTable(this.text).headers;
    },
    rows(): string[][] {
      return parseMarkdownTable(this.text).rows;
    },
  },
});
